import m from 'mithril'
import classNames from 'classnames';

class HeaderComponet {
    constructor(vnode) {

    }
    view({ attrs }) {
        return m(".w-100.position-fixed", {
            style: {
                top: 0,
                backgroundColor: "#FFFFFF",
                boxShadow: "0 4px 6px -6px #222",
                zIndex: 1023,
            }
        }, [
            m(".d-flex.justify-content-between.align-items-center.py-2.w-100", {
                class: classNames({
                    container: !window.isMobile
                }),
                style: {
                    paddingLeft: (!window.isMobile) ? "10.2%" : "10px",
                    paddingRight: (!window.isMobile) ? "10.2%" : "10px",
                }
            }, [
                m("span.px-3", {
                    style: {
                        fontSize: "1rem",
                        color: "#000000",
                        borderRadius: "20px",
                        border: "2px solid #000000",
                        fontWeight: 700,
                        cursor: "pointer",
                    },
                    onclick: (e) => {
                        e.preventDefault()
                        attrs.open_tool_menu(!attrs.open_tool_menu())
                        m.redraw()
                    }
                }, "更多工具"),
                m("span.px-3", {
                    style: {
                        fontSize: "1rem",
                        color: "#000000",
                        borderRadius: "20px",
                        border: "2px solid #000000",
                        fontWeight: 700,
                        cursor: "pointer",
                    },
                    onclick: (e) => {
                        e.preventDefault()
                        attrs.open_user_menu(!attrs.open_user_menu())
                        m.redraw()
                    }
                }, "我的資訊"),
            ])

        ])
    }
}

export default HeaderComponet